// @ts-nocheck
// Landing pública de perfil — abre quando o usuário acessa /@username.
// Deslogado: vê preview (avatar, nome, @, bio, seguidores) + CTA entrar/criar
//   conta + botão "Abrir no app". Após login, é redirecionado pro perfil.
// Logado: resolve o handle e abre o perfil dentro do app imediatamente.
import React, { useEffect, useState } from 'react';
import { Icon } from './icons';
import { api } from '../services/apiV2';
import { OpenInAppBanner } from './open-in-app';
import { AuthSession } from '../types';

export const ProfileLandingScreen: React.FC<{
  handle: string;
  session: AuthSession | null;
  onLoginRequest: () => void;
  onSignupRequest: () => void;
  onOpenProfile: (userId: string) => void;
}> = ({ handle, session, onLoginRequest, onSignupRequest, onOpenProfile }) => {
  const [preview, setPreview] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.getProfilePreview(handle);
        if (cancelled) return;
        setPreview(r);
        // Logado: pula direto pro perfil dentro do app.
        if (session && r?.id) onOpenProfile(r.id);
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Perfil não encontrado');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [handle, session]);

  if (loading) {
    return <div style={{ padding: 80, textAlign: 'center', color: 'var(--ink-3)' }}>Carregando perfil…</div>;
  }
  if (error || !preview) {
    return (
      <div style={{ padding: '60px 20px' }}>
        <div className="serif" style={{ fontSize: 28, lineHeight: 1.05 }}>Perfil indisponível</div>
        <div style={{ color: 'var(--ink-3)', fontSize: 14, marginTop: 12 }}>{error || 'Esse perfil não foi encontrado.'}</div>
      </div>
    );
  }
  // Logado: onOpenProfile já disparou; placeholder enquanto navega pro app.
  if (session) {
    return <div style={{ padding: 80, textAlign: 'center', color: 'var(--ink-3)' }}>Abrindo perfil…</div>;
  }

  const initials = (preview.name || preview.username || '?').slice(0, 2).toUpperCase();
  return (
    <div className="scroll" style={{ paddingBottom: 40 }}>
      <div style={{ padding: '48px 20px 0', textAlign: 'center' }}>
        <div style={{
          width: 96, height: 96, borderRadius: '50%', margin: '0 auto', overflow: 'hidden',
          background: 'linear-gradient(135deg, var(--ember-soft), var(--paper-3))',
          display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid var(--line)',
        }}>
          {preview.avatarUrl
            ? <img src={preview.avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
            : <span className="serif" style={{ fontSize: 34, color: 'var(--ember-2)' }}>{initials}</span>}
        </div>
        <div className="serif" style={{ fontSize: 26, lineHeight: 1.1, marginTop: 14 }}>{preview.name}</div>
        <div className="mono" style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 3 }}>@{preview.username}</div>
        {preview.bio && (
          <div style={{ fontSize: 14, color: 'var(--ink-2)', marginTop: 12, lineHeight: 1.5, fontStyle: 'italic', maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}>
            "{preview.bio}"
          </div>
        )}
        <div style={{ display: 'flex', gap: 18, justifyContent: 'center', marginTop: 16, color: 'var(--ink-3)', fontSize: 12.5 }}>
          <span><strong style={{ color: 'var(--ink)' }}>{preview.followers}</strong> {preview.followers === 1 ? 'seguidor' : 'seguidores'}</span>
          {preview.isPrivate && <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><Icon name="lock" size={12} color="var(--ink-3)"/> privado</span>}
        </div>
      </div>

      <div style={{ padding: '28px 20px 0' }}>
        <div style={{ fontSize: 13.5, color: 'var(--ink-3)', textAlign: 'center', marginBottom: 16, lineHeight: 1.5 }}>
          Entre no Forjamente pra seguir <strong style={{ color: 'var(--ink-2)' }}>{preview.name}</strong> e ler junto.
        </div>
        <button onClick={onSignupRequest} style={{
          width: '100%', padding: '16px', borderRadius: 16, background: 'var(--ember)', color: 'var(--paper)',
          fontSize: 15, fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          boxShadow: '0 14px 28px -10px rgba(199,83,26,0.55)', border: 'none', cursor: 'pointer',
        }}>
          Criar conta e seguir
          <Icon name="arrow-right" size={16} color="var(--paper)"/>
        </button>
        <button onClick={onLoginRequest} style={{
          width: '100%', padding: '14px', marginTop: 8, background: 'transparent', color: 'var(--ink-2)',
          fontSize: 14, fontWeight: 500, border: 'none', cursor: 'pointer',
        }}>
          Já tenho conta · entrar
        </button>
      </div>

      <OpenInAppBanner path={'/@' + preview.username} />
    </div>
  );
};
